import { render, staticRenderFns } from "./SelectedCatalog.vue?vue&type=template&id=34e1c4d8&scoped=true"
import script from "./SelectedCatalog.vue?vue&type=script&lang=js"
export * from "./SelectedCatalog.vue?vue&type=script&lang=js"
import style0 from "./SelectedCatalog.vue?vue&type=style&index=0&id=34e1c4d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e1c4d8",
  null
  
)

export default component.exports